import React from 'react';
import { Flex, Icon, Text } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { FiBarChart2, FiSettings, FiUploadCloud } from 'react-icons/fi';
import { RiDashboardLine, RiMenu2Fill } from 'react-icons/ri';
import { Link, useLocation } from 'react-router-dom';

export const FEED_ANALYSIS_NAV: {
  to: string;
  label: string;
  icon: IconType;
  isActive: (pathname: string) => boolean;
}[] = [
  {
    to: '/menu',
    label: 'Menu',
    icon: RiMenu2Fill,
    isActive: () => false,
  },
  {
    // o detalhe da amostra também acende o painel
    to: '/feed-analysis',
    label: 'Painel',
    icon: RiDashboardLine,
    isActive: pathname =>
      pathname === '/feed-analysis' ||
      pathname.startsWith('/feed-analysis/samples'),
  },
  {
    to: '/feed-analysis/import',
    label: 'Importar laudos',
    icon: FiUploadCloud,
    isActive: pathname => pathname === '/feed-analysis/import',
  },
  {
    to: '/feed-analysis/history',
    label: 'Relatórios',
    icon: FiBarChart2,
    isActive: pathname => pathname === '/feed-analysis/history',
  },
  {
    to: '/feed-analysis/settings',
    label: 'Cadastros',
    icon: FiSettings,
    isActive: pathname => pathname === '/feed-analysis/settings',
  },
];

/** Abas do módulo para telas pequenas (abaixo de `lg` a Sidebar vira Drawer). */
export const MobileNav: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <Flex
      as="nav"
      display={{ base: 'flex', lg: 'none' }}
      bg="gray.800"
      borderWidth="1px"
      borderColor="gray.700"
      borderRadius="lg"
      p="1"
      mb="4"
      gridGap="1"
    >
      {FEED_ANALYSIS_NAV.map(item => {
        const active = item.isActive(pathname);
        return (
          <Flex
            key={item.to}
            as={Link}
            to={item.to}
            flex="1"
            direction="column"
            align="center"
            justify="center"
            gridGap="1"
            py="2"
            px="1"
            borderRadius="md"
            bg={active ? 'blue.500' : 'transparent'}
            color={active ? 'white' : 'gray.400'}
            _hover={{ bg: active ? 'blue.500' : 'gray.700' }}
            aria-current={active ? 'page' : undefined}
          >
            <Icon as={item.icon} fontSize="20" />
            <Text
              fontSize="xs"
              fontWeight="600"
              textAlign="center"
              lineHeight="1.2"
            >
              {item.label}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
};
